var __store = {};

var PageCache = function () {
  this._waiting = {};
  this._listeners = {};
  this._pending = {};
};

PageCache.prototype.get = function (key) { return __store[key]; };
PageCache.prototype.set = function (key, value) {
  if (typeof key === 'object' && !value) {
    for (var keys = Object.keys(key), i = 0; i < keys.length; ++i) {
      this.set(keys[i], key[keys[i]]);
    }
    return this;
  }

  __store[key] = value;

  // Notify any waiters or nexters
  if (this._waiting[key]) {
    this._waiting[key].fulfill(value);
    delete this._waiting[key];
  }

  if (this._listeners[key]) {
    var lstn = this._listeners[key];
    for (var i = 0; i < lstn.length; ++i) {
      lstn[i](value, key);
    }
  }

  return this;
};

PageCache.prototype.maybeSet = function (key, thenable) {
  if (this._pending[key]) {
    throw new Error('page cache already has a pending value for this key');
  }

  // Mark the value as pending
  this._pending[key] = thenable;

  // wait for the promise to resolve
  var self = this;
  thenable.then(function (val) {
    delete self._pending[key];
    self.set(key, val);
    return val;
  }, function (err) {
    console.warn('pending value failed to resolve for key:', key, err); // eslint-disable-line no-console
    delete self._pending[key];
    return err;
  });

  return thenable;
};

PageCache.prototype.await = function (key) {
  if (this._waiting[key]) {
    return this._waiting[key].promise;
  }
  if (__store.hasOwnProperty(key)) {
    return Promise.resolve(__store[key]);
  }

  var waiter = this._waiting[key] = {};
  waiter.promise = new Promise(function (resolve, reject) {
    waiter.fulfill = resolve;
  });
  return waiter.promise;
};

PageCache.prototype.awaitAll = function () {
  var self = this;
  var keys;
  if (arguments.length == 1 && Array.isArray(arguments[0])) {
    keys = arguments[0];
  } else {
    keys = Array.prototype.slice.call(arguments, 0);
  }
  return Promise.all(keys.map(function (k) {
    return self.await(k);
  }));
};

PageCache.prototype.on = function (key, fn) {
  this._listeners[key] || (this._listeners[key] = []);
  this._listeners[key].push(fn);

  return this;
};

PageCache.prototype.off = function (key, fn) {
  var lstn = this._listeners[key];
  if (lstn) {
    var idx = lstn.indexOf(fn);
    if (idx >= 0) {
      this._listeners[key] = lstn.slice(0, idx).concat(lstn.slice(idx + 1));
    }
  }

  return this;
};

PageCache.prototype.one = function (key) {
  var self = this;
  return new Promise(function (resolve, reject) {
    var fn = function (value) {
      resolve(value);
      self.off(key, fn);
    }
    self.on(key, fn);
  });
};

PageCache.prototype.isPending = function (key) {
  return !!this._pending[key];
};

PageCache.prototype.has = function (key) {
  return __store.hasOwnProperty(key);
};

PageCache.prototype.hasOrPending = function (key) {
  return this.has(key) || this.isPending(key);
};

export default new PageCache();

